import React, {Component} from 'react';
import { connect } from 'react-redux';
import Header from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import PostContainer from "../../components/PostContainer";
import { encrypt , decrypt , getParams } from "../../helpers/CryptoJs";
import Chatbar from "../../components/Chatbar";

class Post extends Component {
  constructor(props){
    super(props);
    this.state = {
      urlFeedId  : decrypt(this.props.match.params.id),
    };
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    document.querySelector('body').classList.remove('login_page');
  }
  render() {
    let { stateNames } = this.props;
    return (
      <div className="wrapper">
        <Header/>
        <Sidebar/>
        <PostContainer urlFeedId={this.state.urlFeedId}/>
        <Chatbar />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    stateNames: state.signup
  }
}

const mapDispatchToProps = dispatch => {
  return {
    
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Post);